import React, {Component} from 'react';
import {IWifiAnalyzerResults} from '../../../../../services/AngularServices/WifiAnalyzerService';
import SatelliteAltOutlined from '../../../../../../../img/SatelliteAltOutlined.png';
import {verticalWifi} from '../../../../../components/connectivity-guru/wifi-analyzer-scan/icons';
import {wifiPoint} from '../../../../../components/connectivity-guru/wifi-analyzer-scan/icons';
import './style.scss';
import {InfoBoxCollapsible} from '@techsee/techsee-ui-common/lib/info-box-collapsible';
import {Icon} from '@techsee/techsee-ui-common/lib/icons/simple-icon';
import get from 'lodash/get';

export interface IWifiScanResultTelemetries {
    controller: IWifiAnalyzerResults;
}

class WifiScanResultTelemetries extends Component<IWifiScanResultTelemetries> {
    private static readonly UNAVAILABLE_BSSID = '02:00:00:00:00:00';

    render() {
        const {controller} = this.props;

        const bssids = get(controller, 'wifiConnectionInfo.bssids', []);
        const rssi = get(controller, 'wifiConnectionInfo.rssi', '');
        const frequency = get(controller, 'wifiConnectionInfo.frequency', '');
        const networkName = get(controller, 'wifiConnectionInfo.ssid', '');
        const signalStrengthPercentage = get(controller, 'wifiConnectionInfo.signalStrengthPercentage', '');
        const selectedBssids = get(controller, 'wifiConnectionInfo.macAddress', '');
        const bssidUnavailableTranslated = get(controller, 'bssidUnavailableTranslated', 'BSSID unavailable');
        const updatedSelectedBssids =
            selectedBssids === WifiScanResultTelemetries.UNAVAILABLE_BSSID
                ? bssidUnavailableTranslated
                : selectedBssids;

        return (
            <div className={'wifiScanResultTelemetries-container'}>
                <div className='wifiScanResultTelemetries-ssids'>
                    <div className='wifiScanResultTelemetries-icon-container'>
                        <div> {wifiPoint}</div>
                    </div>
                    <div className='wifiScanResultTelemetries-ssids-details'>
                        <p>{networkName}</p>
                        <div className='wifiScanResultTelemetries-ssids-info'>
                            <p>{updatedSelectedBssids}</p>
                            {bssids.length > 0 && (
                                <InfoBoxCollapsible
                                    content={() => (
                                        <div className={'wifiScanResultTelemetries-ssids-list-container'}>
                                            <p className={'wifiScanResultTelemetries-ssids-list-selected'}>
                                                {updatedSelectedBssids}{' '}
                                                <Icon iconName={'check'} className={'ts-check-blue'}></Icon>
                                            </p>
                                            {bssids
                                                .filter((bssid) => bssid !== selectedBssids)
                                                .map((bssid) => (
                                                    <p key={bssid}>{bssid}</p>
                                                ))}
                                        </div>
                                    )}
                                    icon={''}
                                    className={'wifiScanResultTelemetries-ssids-list'}
                                    id={'wifiScanResultTelemetries-ssids-list'}></InfoBoxCollapsible>
                            )}
                        </div>
                    </div>
                </div>

                <div className='wifiScanResultTelemetries-frequency'>
                    <img src={SatelliteAltOutlined} alt={'SatelliteAltOutlined'} />
                    <div className='wifiScanResultTelemetries-frequency-details'>
                        <p>{frequency}</p>
                        <p>Network</p>
                    </div>
                </div>

                <div className='wifiScanResultTelemetries-rssi'>
                    <div className='wifiScanResultTelemetries-icon-container'>
                        <div> {verticalWifi}</div>
                    </div>

                    <div className='wifiScanResultTelemetries-frequency-details'>
                        <p>{rssi} dBm</p>
                        <p>{signalStrengthPercentage}%</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default WifiScanResultTelemetries;
